import React from 'react';
import { motion } from 'framer-motion';
export function Education() {
  const educationList = [{
    year: '1980',
    institution: 'University of Michigan – Rackham Graduate School',
    degree: 'Master of Science (MS), Biology',
    details: 'Chief OMS Resident, OMS Residency 1977–1980'
  }, {
    year: '1977',
    institution: 'Northwestern University Feinberg School of Medicine',
    degree: 'Anesthesia Fellowship',
    details: 'American Association of Dental Anesthesia'
  }, {
    year: '1976',
    institution: 'Northwestern University School of Dentistry',
    degree: 'Doctor of Dental Surgery (DDS)',
    details: 'Oral Pathology Award'
  }, {
    year: '1972',
    institution: 'University of Utah',
    degree: 'Bachelor of Science (BS), Biology',
    details: 'Cum Laude'
  }];
  const affiliations = ['Academy of Osseointegration', 'American Association of Oral and Maxillofacial Surgeons (AAOMS)', 'American Dental Association (ADA)', 'Chalmers Lyons Society', 'Colorado Dental Association', 'Colorado Society of Oral and Maxillofacial Surgeons (Past President)', 'Metro Denver Dental Society', 'American Society of Anesthesiology (Fellow)'];
  return <section id="education" className="py-24 md:py-32 bg-cream" data-id="element-83">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-84">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-85">
          <div className="w-16 h-px bg-gold mb-6" data-id="element-86"></div>
          <h2 className="font-sans text-gold text-sm uppercase tracking-widest font-medium mb-4" data-id="element-87">
            Academic Foundation
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-navy font-medium leading-tight" data-id="element-88">
            Education
          </h3>
        </motion.div>

        {/* Education List */}
        <div className="space-y-6 mb-24" data-id="element-89">
          {educationList.map((edu, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 md:gap-10 border border-black/5 hover:shadow-md transition-shadow" data-id="element-90">
              <div className="flex-shrink-0 w-24" data-id="element-91">
                <span className="font-serif text-3xl md:text-4xl text-gold font-medium" data-id="element-92">
                  {edu.year}
                </span>
              </div>

              <div className="hidden md:block w-px h-16 bg-gold/30" data-id="element-93"></div>

              <div className="flex-grow" data-id="element-94">
                <h4 className="font-sans text-navy font-semibold text-lg uppercase tracking-wide mb-1" data-id="element-95">
                  {edu.institution}
                </h4>
                <p className="font-serif text-xl text-charcoal mb-1" data-id="element-96">
                  {edu.degree}
                </p>
                <p className="font-sans text-muted text-sm italic" data-id="element-97">
                  {edu.details}
                </p>
              </div>
            </motion.div>)}
        </div>

        {/* Affiliations */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-98">
          <h4 className="font-serif text-2xl text-navy text-center mb-8" data-id="element-99">
            Professional Affiliations
          </h4>
          <div className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-100">
            {affiliations.map((org, index) => <span key={index} className="px-4 py-2 bg-navy/5 border border-gold/30 text-navy font-sans text-sm font-medium tracking-wide rounded-sm hover:bg-navy/10 hover:border-gold transition-colors" data-id="element-101">
                {org}
              </span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}